(function ($, dom) {
	$(function () {
		var $menuPuncts = $('.menuRight__circle');

		$(window).on("scroll", function() {
			if (($(window).scrollTop() > -1) && ($(window).scrollTop() < 601)) {
				$menuPuncts.removeClass('gray active');
				$menuPuncts.eq(0).addClass('active');
			}
			else if (($(window).scrollTop() > 600) && ($(window).scrollTop() < 1501)) {
				$menuPuncts.removeClass('gray active');
				$menuPuncts.eq(1).addClass('active');
			}
			else if (($(window).scrollTop() > 1500) && ($(window).scrollTop() < 2255)) {
				$menuPuncts.addClass('gray');
				$menuPuncts.removeClass('active');
				$menuPuncts.eq(2).addClass('active');
			} else {
				$menuPuncts.removeClass('gray active');
				$menuPuncts.eq(3).addClass('active');
			};
		});

		$('.menuRight__link').on('click', function() {
			console.log($(window).scrollTop());
			var hash = this.hash.replace('#!', ''),
				subhash = '',
				$target = ($(`#${hash}`).length > 0) ? $(`#${hash}`) : $(`.box_${hash}`);

			dom.$mainWrappers.animate({
				scrollTop: $target.offset().top - dom.$header.outerHeight()
			}, 500);
			$menuPuncts.removeClass('active');
			$(this).find('.menuRight__circle').addClass('active');
		});
	});
})(jQuery, app.dom);